// Small, stateless UI atoms shared across the entire app.
import { colors } from "../theme";

const F = "'Montserrat',sans-serif";
const M = "'Montserrat',sans-serif";

export { F, M };

export const Tag = ({ label, c, bg }) => (
  <span style={{
    display:"inline-block", padding:"2px 8px", borderRadius:4, fontSize:10,
    fontWeight:600, color:c||colors.text.body, background:bg||colors.surface.subtle, whiteSpace:"nowrap",
  }}>{label}</span>
);

export const FitTag = ({ v }) => {
  const m = {
    High:   [colors.status.good, colors.status.goodBg],
    Medium: [colors.status.warnText, colors.status.warnBg],
    Low:    [colors.status.bad, colors.status.badBg],
  };
  const [tc, bg] = m[v] || [colors.text.muted, colors.surface.subtle];
  return <Tag label={v} c={tc} bg={bg} />;
};

export const ScoreBadge = ({ v }) => {
  const c  = v >= 70 ? colors.status.good : v >= 50 ? colors.status.warnText : colors.status.bad;
  const bg = v >= 70 ? colors.status.goodBg : v >= 50 ? colors.status.warnBg : colors.status.badBg;
  return (
    <span style={{
      display:"inline-block", padding:"2px 8px", borderRadius:4,
      fontSize:11, fontWeight:700, fontFamily:M, color:c, background:bg,
    }}>{v}</span>
  );
};

export const CrossTag = ({ icon, text, tone }) => {
  const c = tone==="good" ? colors.status.good : tone==="bad" ? colors.status.bad : colors.text.muted;
  return (
    <span style={{
      display:"inline-flex", alignItems:"center", gap:3, fontSize:9,
      fontWeight:tone?600:500, color:c, whiteSpace:"nowrap",
    }}>
      <span style={{opacity:0.85}}>{icon}</span>{text}
    </span>
  );
};

export const KPI = ({ icon, label, value, sub, delta, deltaDir, color, wrap }) => {
  const accent = color || colors.brand.primary;
  // Optional QoQ delta line — colour by direction; "flat" (or baseline) stays muted.
  const deltaColor = deltaDir === "up" ? colors.status.good
    : deltaDir === "down" ? colors.status.bad
    : colors.text.muted;
  return (
  <div style={{
    flex:1, minWidth:140, background:colors.surface.card, borderRadius:10,
    border:`1px solid ${colors.border.subtle}`, borderTop:`3px solid ${accent}`,
    padding:"16px 18px", display:"flex", alignItems:"center", gap:12, overflow:"hidden",
  }}>
    <div style={{
      width:38, height:38, borderRadius:10, background:accent+"26",
      display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0,
    }}>{icon}</div>
    <div style={{minWidth:0, overflow:"hidden"}}>
      <div style={{fontSize:22, fontWeight:800, fontFamily:M, letterSpacing:-0.5, color:colors.text.heading, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis"}}>{value}</div>
      {delta && <div style={{fontSize:10, fontWeight:700, color:deltaColor, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis"}}>{delta}</div>}
      <div style={{fontSize:10, color:colors.text.muted, lineHeight:1.3, whiteSpace: wrap ? "normal" : "nowrap", overflow:"hidden", textOverflow: wrap ? "unset" : "ellipsis"}}>{label}</div>
      {sub && <div style={{fontSize:9, color:typeof sub==="string"&&sub.startsWith("+")?colors.status.good:colors.text.faint, fontWeight:600, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis"}}>{sub}</div>}
    </div>
  </div>
  );
};

/**
 * PageAlert — inline alert banner.
 * type: "info" (neutral) | "warning" (amber) | "empty" (neutral grey)
 * icon: a lucide-react component (optional)
 * title: bold heading
 * message: supporting text (optional)
 */
export const PageAlert = ({ type = "info", icon: Icon, title, message }) => {
  const CFG = {
    info:    { bg:colors.status.infoBg, border:colors.status.infoBorder, accent:colors.brand.primary, heading:colors.text.heading, body:colors.text.body },
    warning: { bg:colors.status.warnBg, border:"#fde68a", accent:colors.brand.orange, heading:colors.status.warnText, body:colors.text.body },
    empty:   { bg:colors.surface.subtle, border:colors.border.subtle, accent:colors.text.faint, heading:colors.text.heading, body:colors.text.muted },
  };
  const { bg, border, accent, heading, body } = CFG[type] || CFG.info;
  return (
    <div style={{
      background:bg, border:`1px solid ${border}`, borderLeft:`4px solid ${accent}`,
      borderRadius:10, padding:"18px 22px", display:"flex", gap:14, alignItems:"flex-start",
    }}>
      {Icon && <Icon size={20} color={accent} style={{flexShrink:0, marginTop:1}} />}
      <div>
        <div style={{fontSize:13, fontWeight:700, color:heading, marginBottom:3, fontFamily:F}}>{title}</div>
        {message && <div style={{fontSize:11, color:body, lineHeight:1.6, fontFamily:F}}>{message}</div>}
      </div>
    </div>
  );
};

export const Btn = ({ label, primary, onClick, icon }) => (
  <button onClick={onClick} style={{
    padding:"6px 14px", borderRadius:6, border:primary?"none":`1px solid ${colors.border.strong}`,
    background:primary?colors.brand.primary:colors.surface.card, color:primary?colors.text.inverse:colors.text.body,
    fontSize:11, fontWeight:600, cursor:"pointer", fontFamily:F,
    display:"inline-flex", alignItems:"center", gap:4,
  }}>
    {icon && <span>{icon}</span>}{label}
  </button>
);
